import { UploadFile } from 'antd';
import dayjs from 'dayjs';
import { FILES_SIZE_LIMIT_MB } from 'common/config';
import { showErrorMessage } from 'common/helpers';

export const uploadExcelFile = (data: ArrayBuffer, fileName: string) => {
  const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${fileName}_${dayjs().format('DDMMYYYYHHmmss')}.xlsx`;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
};

export const checkFileSize = (file: UploadFile) => {
  const isLt5M = !!file.size && file.size / 1024 / 1024 <= FILES_SIZE_LIMIT_MB;

  if (!isLt5M) {
    showErrorMessage('Размер файла не должен превышать 5мб');
    return false;
  }

  return true;
};
